"use strict";
/** state: Final **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var lodash_1 = require("lodash");
var React = require("react");
var Boundary_1 = require("../Boundary");
var CLASS_NAME = 'i-slider';
var CONTAINER_CLASS_NAME = CLASS_NAME + "__container";
var CURRENT_LABEL_CLASS_NAME = CLASS_NAME + "__current-label";
var BOUNDARY_LABELS_CLASS_NAME = CLASS_NAME + "__boundary-labels";
var MIN_LABEL_CLASS_NAME = CLASS_NAME + "__min-label";
var MAX_LABEL_CLASS_NAME = CLASS_NAME + "__max-label";
var TRACK_CLASS_NAME = CLASS_NAME + "__track";
var TRACK_BEFORE_CLASS_NAME = TRACK_CLASS_NAME + "__before";
var TRACK_AFTER_CLASS_NAME = TRACK_CLASS_NAME + "__after";
var STEPS_CLASS_NAME = CLASS_NAME + "__steps";
var STEPS_STEP_CLASS_NAME = STEPS_CLASS_NAME + "__step";
var THUMB_CLASS_NAME = CLASS_NAME + "__thumb";
var THUMB_BUTTON_CLASS_NAME = THUMB_CLASS_NAME + "__button";
/**
 * Sliders allow users to make selection from a range of values.
 */
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider(props) {
        var _this = _super.call(this, props) || this;
        /** id of the first touch event encountered while dragging */
        _this.activeTouchId = undefined;
        _this.containerRef = React.createRef();
        _this.buttonRef = React.createRef();
        _this.renderStep = function (value) {
            var location = '';
            if (value < _this.state.value) {
                location = 'before';
            }
            else if (value > _this.state.value) {
                location = 'after';
            }
            else {
                location = 'current';
            }
            return (React.createElement("div", { key: value, className: classNames(STEPS_STEP_CLASS_NAME, STEPS_STEP_CLASS_NAME + "--" + location) }));
        };
        //#region Helpers
        _this.isEditable = function () {
            var _a = _this.props, disabled = _a.disabled, readOnly = _a.readOnly;
            return !disabled && !readOnly;
        };
        _this.focus = function () {
            if (!_this.props.disabled) {
                _this.buttonRef.current.focus();
            }
        };
        /** Clamps value to the min and max bounds */
        _this.clampValue = function (value) {
            var _a = _this.props, min = _a.min, max = _a.max;
            return Math.min(Math.max(value, min), max);
        };
        /** Rounds value to the nearest step */
        _this.roundValue = function (value) {
            var step = _this.props.step;
            return Math.round(value / step) * step;
        };
        /** Converts value to percent (0..1)*/
        _this.convertValueToPercent = function (value) {
            var _a = _this.props, min = _a.min, max = _a.max;
            if (value === null || value === undefined) {
                return 0;
            }
            return (_this.clampValue(value) - min) / (max - min);
        };
        /** Converts percent (0..1) to value */
        _this.convertPercentToValue = function (percent) {
            var _a = _this.props, min = _a.min, max = _a.max;
            return _this.clampValue((max - min) * percent + min);
        };
        /** Calculates next value based on provided xCoordinate */
        _this.getValue = function (xCoordinate) {
            var rect = _this.containerRef.current.getBoundingClientRect();
            var percent = (xCoordinate - rect.x) / rect.width;
            var value = _this.convertPercentToValue(percent);
            return _this.roundValue(_this.clampValue(value));
        };
        /** Calculates element styles based on provided value */
        _this.getStyles = function (value) {
            var percent = _this.convertValueToPercent(value);
            return {
                thumb: {
                    transform: "translateX(" + percent * 100 + "%)",
                },
                trackAfter: {
                    transform: "\n                    translateY(-50%)\n                    translateX(" + percent * 100 + "%)\n                ",
                },
                trackBefore: {
                    transform: "\n                    translateY(-50%)\n                    translateX(-" + (1 - percent) * 100 + "%)\n                ",
                },
            };
        };
        /** Gets a reference to the first touch encountered while dragging */
        _this.getActiveTouch = function (event) {
            return lodash_1.find(Array.from(event.changedTouches), function (t) { return t.identifier === _this.activeTouchId; });
        };
        /** Gets a reference to first touch from a touch event */
        _this.getFirstTouch = function (event) {
            return event.changedTouches.item(0);
        };
        /** Updates stored state value & notifies listeners  */
        _this.updateValue = function (nextValue) {
            var onChange = _this.props.onChange;
            var prevValue = _this.state.value;
            // Only update state if the value has actually changed
            if (nextValue !== prevValue) {
                _this.setState({
                    value: nextValue,
                });
                onChange && onChange(nextValue);
            }
        };
        //#endregion
        //#region Custom handlers
        _this.handleDragStart = function (xCoordinate) {
            if (!_this.isEditable()) {
                return;
            }
            var onDragStart = _this.props.onDragStart;
            var value = _this.getValue(xCoordinate);
            _this.setState({
                isDragging: true,
            }, _this.focus);
            onDragStart && onDragStart(value);
            _this.updateValue(value);
        };
        _this.handleDragMove = function (xCoordinate) {
            if (!_this.isEditable()) {
                return;
            }
            var value = _this.getValue(xCoordinate);
            _this.updateValue(value);
        };
        _this.handleDragEnd = function (xCoordinate) {
            if (!_this.isEditable()) {
                return;
            }
            var onDragEnd = _this.props.onDragEnd;
            var value = _this.getValue(xCoordinate);
            _this.setState({
                isDragging: false,
            }, _this.focus);
            _this.updateValue(value);
            onDragEnd && onDragEnd(value);
        };
        //#endregion
        //#region Keyboard event handlers
        _this.handleKeyDown = function (event) {
            if (!_this.isEditable()) {
                return;
            }
            var step = _this.props.step;
            var currentValue = _this.state.value;
            // Determine next value
            var nextValue;
            switch (event.key) {
                case 'ArrowRight':
                    nextValue = currentValue + step;
                    break;
                case 'ArrowLeft':
                    nextValue = currentValue - step;
                    break;
                default:
                    nextValue = currentValue;
            }
            // Ensure value is clamped
            nextValue = _this.clampValue(nextValue);
            // Update state
            _this.updateValue(nextValue);
        };
        //#endregion
        //#region Mouse event handlers
        _this.handleClick = function (event) {
            _this.focus();
            if (!_this.isEditable()) {
                return;
            }
            var value = _this.getValue(event.pageX);
            _this.updateValue(value);
        };
        _this.handleMouseDown = function (event) {
            document.body.addEventListener('mousemove', _this.handleMouseMove);
            document.body.addEventListener('mouseup', _this.handleMouseUp);
            _this.handleDragStart(event.pageX);
        };
        _this.handleMouseMove = function (event) {
            _this.handleDragMove(event.pageX);
        };
        _this.handleMouseUp = function (event) {
            document.body.removeEventListener('mousemove', _this.handleMouseMove);
            document.body.removeEventListener('mouseup', _this.handleMouseUp);
            _this.handleDragEnd(event.pageX);
        };
        //#endregion
        //#region Touch event handlers
        _this.handleTouchStart = function (event) {
            document.body.addEventListener('touchmove', _this.handleTouchMove);
            document.body.addEventListener('touchend', _this.handleTouchEnd);
            document.body.addEventListener('touchcancel', _this.handleTouchEnd);
            var touch = _this.getFirstTouch(event);
            if (touch) {
                // Store a reference to first touch identifier
                _this.activeTouchId = touch.identifier;
                _this.handleDragStart(touch.pageX);
            }
        };
        _this.handleTouchMove = function (event) {
            var touch = _this.getActiveTouch(event);
            if (touch) {
                _this.handleDragMove(touch.pageX);
            }
        };
        _this.handleTouchEnd = function (event) {
            document.body.removeEventListener('touchmove', _this.handleTouchMove);
            document.body.removeEventListener('touchend', _this.handleTouchEnd);
            document.body.removeEventListener('touchcancel', _this.handleTouchEnd);
            var touch = _this.getActiveTouch(event);
            if (touch) {
                // Clear stored touch reference
                _this.activeTouchId = null;
                _this.handleDragEnd(touch.pageX);
            }
        };
        _this.state = {
            isDragging: false,
            value: props.value !== undefined && props.value !== null
                ? props.value
                : props.defaultValue,
        };
        return _this;
    }
    Slider.getDerivedStateFromProps = function (props, state) {
        if (props.value !== undefined && props.value !== state.value) {
            return {
                value: props.value,
            };
        }
        return null;
    };
    Slider.prototype.render = function () {
        var _a, _b;
        var _c = this.props, label = _c.label, currentLabel = _c.currentLabel, minLabel = _c.minLabel, maxLabel = _c.maxLabel, hideCurrentLabel = _c.hideCurrentLabel, hideBoundaryLabels = _c.hideBoundaryLabels, className = _c.className, defaultValue = _c.defaultValue, max = _c.max, min = _c.min, disabled = _c.disabled, readOnly = _c.readOnly, showSteps = _c.showSteps, 
        // Omit
        onChange = _c.onChange, onDragStart = _c.onDragStart, onDragEnd = _c.onDragEnd, step = _c.step, _ = _c.value, restProps = __rest(_c, ["label", "currentLabel", "minLabel", "maxLabel", "hideCurrentLabel", "hideBoundaryLabels", "className", "defaultValue", "max", "min", "disabled", "readOnly", "showSteps", "onChange", "onDragStart", "onDragEnd", "step", "value"]);
        var _d = this.state, value = _d.value, isDragging = _d.isDragging;
        var styles = this.getStyles(value);
        return (React.createElement("div", __assign({ className: classNames(CLASS_NAME, className, (_a = {},
                _a[CLASS_NAME + "--disabled"] = disabled,
                _a[CLASS_NAME + "--readonly"] = readOnly,
                _a)), role: "slider", "aria-valuenow": value, "aria-valuemin": min, "aria-valuemax": max, onClick: this.handleClick, onMouseDown: this.handleMouseDown, onTouchStart: this.handleTouchStart, onKeyDown: this.handleKeyDown, ref: this.containerRef }, restProps),
            !hideCurrentLabel && (React.createElement(Boundary_1.Boundary, { className: CURRENT_LABEL_CLASS_NAME, xOffset: this.convertValueToPercent(value) - 0.5 }, currentLabel !== undefined ? currentLabel : value)),
            React.createElement("div", { className: CONTAINER_CLASS_NAME },
                React.createElement("div", { className: TRACK_CLASS_NAME },
                    React.createElement("div", { className: TRACK_BEFORE_CLASS_NAME, style: styles.trackBefore }),
                    React.createElement("div", { className: TRACK_AFTER_CLASS_NAME, style: styles.trackAfter })),
                showSteps && (React.createElement("div", { className: STEPS_CLASS_NAME }, lodash_1.range(min, max + 1, step).map(this.renderStep))),
                React.createElement("div", { className: THUMB_CLASS_NAME, style: styles.thumb },
                    React.createElement("button", { className: classNames(THUMB_BUTTON_CLASS_NAME, (_b = {},
                            _b[THUMB_BUTTON_CLASS_NAME + "--dragging"] = isDragging,
                            _b)), onMouseDown: this.handleMouseDown, onTouchStart: this.handleTouchStart, onKeyDown: this.handleKeyDown, disabled: disabled, "aria-label": String(label), ref: this.buttonRef }))),
            !hideBoundaryLabels && (React.createElement("div", { className: BOUNDARY_LABELS_CLASS_NAME },
                React.createElement("div", { className: MIN_LABEL_CLASS_NAME }, minLabel !== undefined ? minLabel : min),
                React.createElement("div", { className: MAX_LABEL_CLASS_NAME }, maxLabel !== undefined ? maxLabel : max)))));
    };
    Slider.defaultProps = {
        disabled: false,
        max: 100,
        min: 0,
        readOnly: false,
        step: 1,
    };
    return Slider;
}(React.Component));
exports.Slider = Slider;
//# sourceMappingURL=Slider.js.map